import React from 'react';

export const copyToClipBoard = async (_text, _pop = false) => {
    try {
        await navigator.clipboard.writeText(_text);
        if (_pop) {
            alert('Copiado!');
        }
    } catch (err) {
        console.log(err)
        alert('Falha ao copiar.');
    }
};


const HidePass = (props) => {
    const { _pass, _txt, _style } = props
    return (
        <div
            style={_style ? _style : {}}
            onClick={() => {
                if (_pass) {
                    copyToClipBoard(_pass)
                }
            }}
        >
            <b>{_txt ? _txt : ''} </b>{_pass.replaceAll(/[^ ]/g, '*')}
        </div>
    )
}

export const msToDateTime = (ms) => {
    const d = new Date(ms)
    const dia_s = {
        0: 'domingo',
        1: 'segunda',
        2: 'terça',
        3: 'quarta',
        4: 'quinta',
        5: 'sexta',
        6: 'sábado'
    }
    const ret = {
        n_dia_semana: d.getDay(), // dia 0 = domingo
        dia_semana: dia_s[d.getDay()],
        data: `${d.getDate() < 10 ? '0' : ''}${d.getDate()}`,
        mes: `${(d.getMonth() + 1) < 10 ? '0' : ''}${d.getMonth() + 1}`,
        ano: d.getFullYear(),
        hora: d.getHours(),
        minuto: d.getMinutes(),
        segundos: d.getSeconds(),
        iso_i: `${d.getFullYear()}-${(d.getMonth() + 1) < 10 ? '0' : ''}${d.getMonth() + 1}-${d.getDate() < 10 ? '0' : ''}${d.getDate()} ${d.getHours() < 10 ? '0' : ''}${d.getHours()}:${d.getMinutes() < 10 ? '0' : ''}${d.getMinutes()}:${d.getSeconds() < 10 ? '0' : ''}${d.getSeconds()}`,
        iso2: d.toISOString()
    }
    return ret
}

export const msToTime = (ms) => {
    if (ms > 0) {
        var hours = ms / (1000 * 60 * 60);
        var absoluteHours = Math.floor(hours);
        var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

        //Get remainder from hours and convert to minutes
        var minutes = (hours - absoluteHours) * 60;
        var absoluteMinutes = Math.floor(minutes);
        var m = absoluteMinutes > 9 ? absoluteMinutes : '0' + absoluteMinutes;

        //Get remainder from minutes and convert to seconds
        var seconds = (minutes - absoluteMinutes) * 60;
        var absoluteSeconds = Math.floor(seconds);
        var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;
        return ({
            horas: h,
            minutos: m,
            segundos: s
        })
    } else {
        return ({
            horas: '00',
            minutos: '00',
            segundos: '00'
        })
    }
}

export const msToElapsedTime = (ms) => {
    if (ms > 0) {
        var hours = ms / (1000 * 60 * 60);
        var absoluteHours = Math.floor(hours);
        var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

        //Get remainder from hours and convert to minutes
        var minutes = (hours - absoluteHours) * 60;
        var absoluteMinutes = Math.floor(minutes);
        var m = absoluteMinutes > 9 ? absoluteMinutes : '0' + absoluteMinutes;

        //Get remainder from minutes and convert to seconds
        var seconds = (minutes - absoluteMinutes) * 60;
        var absoluteSeconds = Math.floor(seconds);
        var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;
        return ({
            horas: h,
            minutos: m,
            segundos: s,
            str: `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
        })
    } else {
        return ({
            horas: '00',
            minutos: '00',
            segundos: '00',
            str: '00:00:00'
        })
    }
}

export const groupArrObjByKey = (_data, _key) => {
    const temp = _data.reduce(function (r, a) {
        r[a[_key]] = r[a[_key]] || [];
        r[a[_key]].push(a);
        return r;
    }, Object.create(null))

    return temp
}

export const getTimeZone = (date) => {
    const temp = new Date(new Date(date).getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0]
    return temp
}

export const randomString = (length) => {
    const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}



export function createDaysOfMonthObject(_month=false, _year=false) {
    // const today = new Date(); // Pega a data e hora atuais
    // const currentYear = today.getFullYear(); // Pega o ano atual
    // const currentMonth = today.getMonth(); // Pega o mês atual (0-11, onde 0 é Janeiro)

    // // Calcula o número de dias no mês atual
    // // Para isso, pegamos o dia 0 do próximo mês, que efetivamente nos dá o último dia do mês atual.
    // const numberOfDaysOnMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    // const datesOfMonth = {}; // Objeto para armazenar as datas

    // // Itera por cada dia do mês
    // for (let day = 1; day <= numberOfDaysOnMonth; day++) {
    //     // Cria um objeto Date para o dia atual do loop, no ano e mês atuais
    //     // Note que o mês no construtor de Date é 0-indexado.
    //     datesOfMonth[day] = { day, qty: 0 }//new Date(currentYear, currentMonth, dia);
    // }
    // return datesOfMonth;

    const today = (_month && _year) ? new Date(_year, _month, 1) : new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // Mês é baseado em zero (0 = Janeiro, 11 = Dezembro)

    const daysOfMonth = new Date(year, month + 1, 0).getDate(); // Pega o último dia do mês corrente
    const daysOfMonthObject = {};

    const namesOfDays = [
        "Domingo", "Segunda-feira", "Terça-feira",
        "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"
    ];

    for (let d = 1; d<= daysOfMonth; d++) {
        // console.log(d)
        daysOfMonthObject[d] = {day: d, qty:0}//namesOfDays[dataEspecifica.getDay()];
    }

    return daysOfMonthObject;
}




export default HidePass;